import { render, staticRenderFns } from "./AddOptionGroup.vue?vue&type=template&id=379c22b0"
import script from "./AddOptionGroup.vue?vue&type=script&lang=js"
export * from "./AddOptionGroup.vue?vue&type=script&lang=js"
import style0 from "./AddOptionGroup.vue?vue&type=style&index=0&id=379c22b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports